export const ENV = {
    BACKEND: 'https://big.kapsi.fi'
}